import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-masjids',
  imports: [PagePlaceholderComponent],
  templateUrl: './masjids.component.html',
  styleUrl: './masjids.component.scss'
})
export class MasjidsComponent {
  protected readonly icon = '🕌';
  protected readonly pageTitle = 'pages.masjids.title';
  protected readonly subtitle = 'pages.masjids.subtitle';
}
